var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        label: "CPF/CNPJ",
        "label-for": "cpf-cnpj",
        description:
          "Digite o CPF no formato XXX.XXX.XXX-XX ou o CNPJ no formato XX.XXX.XXX/XXXX-XX"
      }
    },
    [
      _c("b-form-input", {
        attrs: {
          id: "cpf-cnpj",
          type: "text",
          placeholder: "XXX.XXX.XXX-XX ou XX.XXX.XXX/XXXX-XX",
          required: "",
          state: _vm.cpfCnpjState,
          "aria-describedby": "cpf-cnpj-feedback"
        },
        on: { blur: _vm.validateCpfCnpj },
        model: {
          value: _vm.formattedCpfCnpj,
          callback: function($$v) {
            _vm.formattedCpfCnpj = $$v
          },
          expression: "formattedCpfCnpj"
        }
      }),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { id: "cpf-cnpj-feedback" } }, [
        _vm._v("\n    Por favor, insira um CPF ou CNPJ válido.\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }